import { createFileRoute } from '@tanstack/react-router'
import { BarcodeImportPage } from '@/components/pages/inventory/purchase-order/product-import/page'

export const Route = createFileRoute('/_app/backend-settings/product-import/')({
  component: BarcodeImportPage,
})
